import React from 'react';
import { RoutedTabContainer } from 'Components/Common/RoutedTabs/RoutedTabContainer';
import { RoutedTab } from 'Components/Common/RoutedTabs/RoutedTab';
import ViewLicenceTypes from './ViewLicenceType';
import AddLicenceType from './AddLicenceType';

const licenceTypesTabs: readonly RoutedTab[] = [
   {
      label: 'View',
      route: '',
      component: ViewLicenceTypes,
      pageTitle: 'View',
      exact: true,
      permissions: 'SystemParameter.Read',
   },
   {
      label: 'Add',
      route: '/add',
      component: AddLicenceType,
      pageTitle: 'Add',
      permissions: 'SystemParameter.Create',
   },
];

const LicenceType = (): JSX.Element => {
   return (
      <RoutedTabContainer
         tabs={licenceTypesTabs}
         baseUrl="/superuser/licence-type"
         panelClassName="licenceType"
         pageTitle="Licence Type"
      />
   );
};

export default LicenceType;
